import { useNavigate } from 'react-router-dom'
import { MoreVertical } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { navigateInParent } from '@/lib/app-messaging'
import { useLanguage } from '@/contexts/language-context'

interface WorkerActionsMenuProps {
  userProfileId: number
  workerName: string
  toggleQuery?: string
}

export function WorkerActionsMenu({ userProfileId, workerName, toggleQuery }: WorkerActionsMenuProps) {
  const navigate = useNavigate()
  const { dictionary } = useLanguage()
  const t = dictionary?.resourceAvailability?.workerActions
  const suffix = toggleQuery ? `?${toggleQuery}` : ''
  const triggerAriaLabel = (t?.triggerAriaLabel || 'Actions for {name}').replace('{name}', workerName)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={triggerAriaLabel}
          className="rounded p-1 text-muted-foreground hover:bg-muted hover:text-foreground focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <MoreVertical className="w-4 h-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-auto">
        <DropdownMenuItem
          onSelect={() => navigate(`/availability/${userProfileId}${suffix}`)}
          className="whitespace-nowrap"
        >
          {t?.showBreakdown || 'Show engagement breakdown'}
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => navigateInParent(`/next/contact/userprofile/${userProfileId}`, { openInNewTab: true })}
          className="whitespace-nowrap"
        >
          {t?.openProfileNewTab || 'Open user profile in new tab'}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
